export default __webpack_public_path__ + "static/media/Pre-RegistrationTextKR.1dbabf47.svg";